export default __webpack_public_path__ + "static/media/frame214N.8a023c85.svg";